import { Option, SelectOption } from "../components/common/forms/Interfaces";
import { Nullable } from "../models/Common";

export class OptionMap<Type extends string> {
  private map: Map<Type, string> = new Map<Type, string>();
  constructor(options: Record<Type, string>) {
    for (const [key, value] of Object.entries(options)) {
      this.map.set(key as Type, value as string);
    }
  }

  addOption(key: Type, label: string): void {
    this.map.set(key, label);
  }

  getLabel(key: Type): string | undefined {
    return this.map.get(key);
  }

  getOptions(): Option<Type>[] {
    return Array.from(this.map.entries()).map(
      ([type, label]: [string, string]): Option<Type> => ({
        title: label,
        value: type as Type,
      })
    );
  }

  getSelectOptions(prefix = ""): SelectOption[] {
    return Array.from(this.map.entries()).map(
      ([type, label]: [string, string]): SelectOption => ({
        value: `${prefix}${type}`,
        label: label,
      })
    );
  }

  parsePrefix(value: string, prefix = ""): Nullable<Type> {
    if (!value.startsWith(prefix)) {
      return null;
    }

    const originalValue = value.slice(prefix.length);
    const originalKey = Array.from(this.map.keys()).find(
      (key: Type) => key === originalValue
    );

    if (originalKey === undefined) {
      return null;
    }

    return originalKey;
  }
}
